var datetimeinte =  setInterval(function(){

var timeZone = "Australia/Queensland";
var today = new Date(),
mm = today.getMonth(),
yyyy = today.getFullYear();
const month = today.toLocaleString('default', { month: 'short' });

var nowTimeZone2 = today.toLocaleString("en-AU", {timeZone: "Australia/Queensland"});
var spl  =  nowTimeZone2.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
var splits = spl.split("-");

var dd = splits[0];
// console.log(dd);
var TimerEndDate = month+" "+dd+" "+yyyy;

var startTime = new Date(mm + '/' + dd + '/' + yyyy);
/* set endtime */
var endHour = 13;
var endMinute = 00;
var endSeconds = 00;

var hrsn = splits[3];
var minssn = splits[4];
var totaln = hrsn+''+minssn;


//for starting time for timer
//bydefault set to Australia current time
var nowDate = new Date();

var nowTimeZone = convertTZ(nowDate, timeZone);




var now = new Date(nowTimeZone.getFullYear(),nowTimeZone.getMonth(),nowTimeZone.getDate());
now.setHours(nowTimeZone.getHours(), nowTimeZone.getMinutes(), nowTimeZone.getSeconds());

var endDate = new Date(TimerEndDate+" "+endHour+":"+endMinute+":"+endSeconds);

var endDateTime = convertTZ(endDate, timeZone);

var future = new Date(endDateTime.getFullYear(),endDateTime.getMonth(),endDateTime.getDate());
future.setHours(endHour, endMinute, endSeconds);

var difference = Math.floor((future - now) / 1000);

var seconds = fixIntegers(difference % 60);
difference = Math.floor(difference / 60);

var minutes = fixIntegers(difference % 60);
difference = Math.floor(difference / 60);

var hours = fixIntegers(difference % 24);
difference = Math.floor(difference / 24);

// console.log('endDate'+endDate +'nowDate'+nowDate);
var days = difference;
$("#seconds").text(seconds + "S");
$("#minutes").text(minutes + "M");
$("#hours").text(hours + "H");
var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
var currentday = days[new Date().getDay()];

if(hours ==0 && minutes == 0 && seconds == 0){
$('.cstm_count_downtimer').addClass('inactive');
$('.cstm_count_downtimer1').addClass('active');
clearInterval(datetimeinte);
}else if(currentday =='Saturday' || currentday =='Sunday'){
$('.cstm_count_downtimer').addClass('inactive');

}else{
$('.cstm_count_downtimer').removeClass('inactive');
$('.cstm_count_downtimer1').removeClass('active');
}




// console.log(Intl.DateTimeFormat().resolvedOptions().timeZone);

}, 1000);
function convertTZ(date, tzString) {
var tzone = "Australia/Queensland";
return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", {timeZone: tzone}));
}
  
function fixIntegers(integer)
{
if (integer < 0)
integer = 0;
if (integer < 10)
return "0" + integer;
return "" + integer;
}